import {svgIconWrapper} from '../svg-icon-wrapper';

import ZapierRegular from './zapier-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ZapierRegular {...props} />;
}

SvgComponent.iconName = 'zapierRegular';

export const ZapierRegularIcon = svgIconWrapper(SvgComponent);
